// JQ4-45 · US-AUDIT-005 — Super Admin Audit Log route
//
// Access: super_admin only (super-admin context).
// The _authenticated.super-admin.tsx layout already redirects non-super_admin
// roles to /dashboard, so no additional gate is needed here.
//
// NOTE: .index.tsx suffix REQUIRED per TanStack Router file-based routing convention.

import { createFileRoute } from '@tanstack/react-router';

import { SuperAdminAuditLogPage } from '../modules/audit-log/ui/pages/SuperAdminAuditLogPage';

export const Route = createFileRoute('/_authenticated/super-admin/audit-log/')({
  component: SuperAdminAuditLogPage,
  staticData: {
    breadcrumb: ['Audit', 'Audit Log'],
  },
});
